'use client';

import { useState } from 'react';
import HeaderLine from '../font/headerline';
import Header from '../font/header1';
import Header2 from '../font/header2';
import H4 from '../font/H4';
import dashboard from '../../img/screenshots/dashboard.png';
import allProjects from '../../img/screenshots/all_project.png';
import spending from '../../img/screenshots/spending.png';
import projectDetail from '../../img/screenshots/project_detail.png';

const tabs = [
    {
        id: 'dashboard',
        label: 'Dashboard',
        image: dashboard,
        alt: 'HomeButler dashboard showing priority projects and upcoming appointments',
        title: 'Your home, triaged for you',
        description: "Every morning HomeButler surfaces what needs attention next, ranked by risk. Upcoming quote visits and work sessions show up automatically, so nothing falls through the cracks.",
    },
    {
        id: 'projects',
        label: 'All Projects',
        image: allProjects,
        alt: 'HomeButler project list showing risk level and status for every home project',
        title: 'Every project, one list',
        description: 'Filter by Active, Critical, Hiring, or Done. Each project shows its risk score and current stage, from finding a pro to getting quotes to marking the work complete.',
    },
    {
        id: 'spending',
        label: 'Spending',
        image: spending,
        alt: 'HomeButler spending report showing cash out, owed, and pending totals by system',
        title: 'Know where your money is going',
        description: "See what you've already paid, what's owed, and what's still pending in quotes, broken down by system (plumbing, roof, and more) so you can budget with confidence.",
    },
    {
        id: 'project',
        label: 'Project Detail',
        image: projectDetail,
        alt: 'HomeButler project detail showing quotes from pros and project status',
        title: 'Compare quotes side by side',
        description: 'Request quotes from vetted pros, compare pricing as it comes in, and track the job from first estimate to appointment to completion, all in one place.',
    },
];

const AppPreview = () => {
    const [activeTab, setActiveTab] = useState(tabs[0].id);
    const active = tabs.find((tab) => tab.id === activeTab);

    return (
        <div className="flex flex-col justify-center pt-16 lg:pt-24 lg:p-10 bg-lightblue">
            <div className="flex flex-row">
                <HeaderLine />
                <div className="flex flex-col place-items-center flex-1 lg:flex-none w-full lg:w-auto px-4">
                    <Header>See it in action</Header>
                </div>
                <HeaderLine />
            </div>
            <Header2>A real look at the dashboard that runs your home</Header2>
            <div className="flex flex-wrap justify-center gap-3 pb-8 px-4">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`px-5 py-2 rounded-full font-semibold transition-colors ${
                            activeTab === tab.id
                                ? 'bg-pink text-white'
                                : 'bg-white text-darkblue border border-grey2'
                        }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div className="px-4 lg:px-0 max-w-5xl w-full mx-auto">
                <div className="rounded-xl bg-darkblue p-3 shadow-xl">
                    <div className="flex flex-row gap-2 px-2 pb-3">
                        <span className="w-3 h-3 rounded-full bg-pink"></span>
                        <span className="w-3 h-3 rounded-full bg-blue"></span>
                        <span className="w-3 h-3 rounded-full bg-extraskyblue"></span>
                    </div>
                    <p className="text-extraskyblue text-xs text-center pb-2 lg:hidden">Scroll to explore &rarr;</p>
                    <div className="overflow-x-auto rounded-lg">
                        <img
                            src={active.image}
                            alt={active.alt}
                            className="h-auto rounded-lg border border-bluegrey w-[640px] max-w-none lg:w-full lg:max-w-full"
                        />
                    </div>
                </div>
                <div className="flex flex-col items-center text-center pt-8 pb-4 px-4">
                    <H4>{active.title}</H4>
                    <p className="max-w-2xl pt-2">{active.description}</p>
                </div>
            </div>
        </div>
    );
};

export default AppPreview;
